<template>
  <el-upload
    class="multiple-uploader"
    :multiple="true"
    :action="uploadIp + '/job/uploadImages'"
    :headers="headers"
    :on-success="handleMultipleSuccess"
    :on-remove="handleRemove"
    :before-upload="beforeUpload"
    list-type="picture">
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">只能上传2MB以内的png,jpg,jpeg格式文件</div>
  </el-upload>
</template>

<script>
import config from '@/utils/index'
export default {
  name: 'MultipleUpload',
  data() {
    return {
      uploadIp: config.uploadIp,
      imgIp: config.imgIp,
      fileList: [],
      valueId: []
    }
  },
  computed: {
    headers() {
      return {
        Authorization: this.$store.state.user.token
      }
    }
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.valueId = []
      fileList.forEach(element => {
        this.valueId.push(element.response.data.imageId)
      });
      this.$emit('uploadMultipleSuccess', this.valueId)
    },
    handleMultipleSuccess(res, file) {
      this.fileList.push({
        name: file.name,
        url: URL.createObjectURL(file.raw),
        id: res.data.imageId
      })
      this.valueId.push(res.data.imageId)
      this.$emit('uploadMultipleSuccess', this.valueId)
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false
      }
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (fileType.toLowerCase() === 'png' || fileType.toLowerCase() === 'jpg' || fileType.toLowerCase() === 'jpeg') {
        return true
      } else {
        this.$message.error('上传图片格式只支持png,jpg,jpeg格式');
        return false
      }
    }
  }
}
</script>